<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" v-loading="loading" :element-loading-text="loadTxt">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">标题<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="addObj.title"></textarea>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">副标题</p>
          <div class="write-text">
            <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="addObj.subtitle"></textarea>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.type_id" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">上传图片<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
              <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://upload.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadImg"
              :on-success="handleSuccessImg"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveImg"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://pic.speechcoach.cn/' + addObj.image"
                alt=""
              />
            </el-dialog>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <!-- 关卡设置 -->
      <div class="levelBox MobelBox" v-if="levelType">
        <div class="write-txt">
          <p class="write-title">关卡数量<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入1～50正整数" v-model="levelObj.num">
            <span>请输入1～50正整数</span>
          </div>
          <button class="btn btn-create" @click="createSub">生成</button>
        </div>
        <div class="write-txt write-level">
          <p class="write-title" v-for="(item,index) in levelObj.level" :key="index" :class="levelIndex==item.num?'select':''" @click="levelSub(item)">关卡{{item.num}}</p>
        </div>
        <div class="write-list" v-for="(item,index) in levelObj.level" :key="'level'+index" v-show="levelIndex==item.num">
          <div class="write-txt">
            <p class="write-title">标题{{item.num}}<span>*</span></p>
            <div class="write-text">
              <input type="text" placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.title">
              <span>最多输入30个中/英、数字和特殊符号</span>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">副标题<span>*</span></p>
            <div class="write-text">
              <input type="text" placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.subtitle">
              <span>最多输入30个中/英、数字和特殊符号</span>
            </div>
          </div>
          <div style="display:block;" v-if="detailType==1">
            <div class="write-txt">
              <p class="write-title">分值<span>*</span></p>
              <div class="write-text">
                <input type="number" placeholder="请输入1～100正整数" v-model="item.score">
                <span>请输入1～100正整数</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">数字人名称<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.ph_name">
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">数字人头像<span>*</span></p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.ph_headpic">
                  <img :src="'https://pic.speechcoach.cn/'+item.ph_headpic" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList,index,'ph_headpic')}"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.speechcoach.cn/' + item.ph_headpic"
                    alt=""
                  />
                </el-dialog>
              </div>
            </div>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="levelSave">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <!-- 练习设置 -->
      <div class="examBox MobelBox" v-if="examType">
        
        <div class="write-txt write-level">
          <p class="write-title" v-for="(item,index) in examObj.level" :key="index" :class="examIndex==index?'select':''" @click="levelSub(item,'exam',index)">关卡{{(index+1)}}</p>
        </div>
        <div class="userList" v-if="detailType==1">
          <div class="user-item" v-for="(item,index) in examObj.level" :key="index" v-show="examIndex==index">
            <div class="user-item-name" v-for="(ele,num) in item.image_videos" :key="num">
              <p class="user-title">数字人{{(num+1)}}</p>
              <button class="btn btn-add" @click="userAdd(item)" v-if="num==0">添加数字人</button>
              <button class="btn btn-remove" @click="userRemove(item,num)" v-if="num > 0">删除数字人</button>
              <div class="video-upload">
                <div class="write-txt">
                  <p class="write-title">上传封面<span>*</span></p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.image">
                      <img :src="'https://pic.speechcoach.cn/'+ele.image" alt="">
                      <div class="hover" v-if="imgType">
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadImg"
                      :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList,index,'user_banner',num)}"
                      :on-progress="handleProgressImg"
                      :on-remove="handleRemoveImg"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.speechcoach.cn/' + ele.image"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>

                <div class="write-txt" >
                  <p class="write-title">上传动态视频<span>*</span></p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.video">
                      <video :src="'https://pic.speechcoach.cn/'+ele.video" alt=""></video>
                      <div class="hover" v-if="imgType">
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadVideo"
                      :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'video',num)}"
                      :on-progress="handleProgressImg"
                      :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'video',num)}"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.bi-rong.com/' + ele.video"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>

                <div class="write-txt" >
                  <p class="write-title">上传静态视频<span>*</span></p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.static_video">
                      <video :src="'https://pic.speechcoach.cn/'+ele.static_video" alt=""></video>
                      <div class="hover" v-if="imgType">
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadVideo"
                      :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'static_video',num)}"
                      :on-progress="handleProgressImg"
                      :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'static_video',num)}"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.bi-rong.com/' + ele.static_video"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>

                <div class="write-txt" >
                  <p class="write-title">音频<span>*</span></p>
                  <input type="text" v-model="ele.timbre">
                </div>
              </div>
              
            </div>
            
            <div class="question-list">
              <div class="question-item" v-for="(ele,num) in item.topics" :key="num">
                <div class="question-text" v-if="num===0">
                  <p class="question-title">问题1 （固定问题）</p>
                  <div class="question-btnBox">
                    <button class="btn btn-question-add" @click="questionAdd(index)">添加</button>
                  </div>
                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>时长：</p>
                    <div class="question-cont-time">
                      <div class="time" v-for="(i,k) in ele.option" :key="k">
                        <input type="text" placeholder="请输入60以内的正整数" v-model="i.content">
                        <span>分钟</span>
                        <button class="btn btn-time-add" v-if="k == 0" @click="timeAdd(ele)">添加时长</button>
                        <button class="btn btn-time-remove" v-if="k > 0" @click="timeRemove(ele,k)">删除时长</button>
                        <el-checkbox v-model="i.is_vip" @change="$forceUpdate()">是否vip</el-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>AI提示词：</p>
                    <div class="question-cont-time">
                      <div class="time">
                        <textarea placeholder="最多输入3000个中/英、数字和特殊符号" v-model="ele.topic_ai"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="question-text" v-else>
                  <p class="question-title">问题{{(num+1)}}</p>
                  <div class="question-btnBox">
                    <button class="btn btn-question-add" @click="questionAdd(index)">添加</button>
                    <button class="btn btn-question-remove" @click="questionRemove(index,num)">删除</button>
                  </div>

                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>问题名称：</p>
                    <div class="question-cont-time">
                      <div class="time">
                        <input type="text" placeholder="最多输入50个中/英、数字和特殊符号" v-model="ele.topic">
                      </div>
                    </div>
                  </div>
                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>AI提示词：</p>
                    <div class="question-cont-time">
                      <div class="time">
                        <textarea placeholder="最多输入3000个中/英、数字和特殊符号" v-model="ele.topic_ai"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>是否必填/必选：</p>
                    <div class="question-cont-time">
                      <el-radio-group v-model="ele.is_must" @change="$forceUpdate()">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="question-cont">
                    <p class="question-cont-title"><span>*</span>选择问题类型：</p>
                    <div class="question-cont-time">
                      <el-radio-group v-model="ele.topic_type" @change="topicChange(ele,index,num)">
                        <el-radio :label="1">填空</el-radio>
                        <el-radio :label="2">单选</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="question-cont" v-if="ele.topic_type==1">
                    <p class="question-cont-title" style="opacity: 0;"><span>*</span>选择问题类型：{{ele.topic_type}}</p>
                    <div class="question-cont-time">
                      <textarea placeholder="最多输入3000个中/英、数字和特殊符号" v-model="ele.fib"></textarea>
                    </div>
                  </div>
                  <div class="question-cont" v-if="ele.topic_type==2">
                    <div v-for="(i,k) in ele.option" :key="k" style="margin: 10px 0;">
                      <p class="question-cont-title"><span>*</span>选项：</p>
                      <div class="question-cont-time">
                        <textarea placeholder="" v-model="i.content"></textarea>
                      </div>
                      <button class="btn btn-option-add" @click="optionAdd(ele)">添加</button>
                      <button class="btn btn-option-remove" @click="optionRemove(ele,k)">删除</button>
                      <!-- <el-checkbox v-model="i.is_vip" @change="$forceUpdate()">试用</el-checkbox> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="comment">
              <div class="write-txt">
                <p class="write-title">欢迎语：<span>*</span></p>
                <div class="write-text">
                  <!-- <input type="text" placeholder="最多输入1000个中/英、数字和特殊符号" v-model="item.message"> -->
                  <textarea placeholder="最多输入1000个中/英、数字和特殊符号" v-model="item.message"></textarea>
                  <span>最多输入1000个中/英、数字和特殊符号</span>
                </div>
              </div>
              <div class="write-txt">
                <p class="write-title">对话AI提示：<span>*</span></p>
                <div class="write-text">
                  <!-- <input type="text" placeholder="最多输入3000个中/英、数字和特殊符号" v-model="item.dialogue_ai"> -->
                  <textarea placeholder="最多输入3000个中/英、数字和特殊符号" v-model="item.dialogue_ai"></textarea>
                  <span>最多输入3000个中/英、数字和特殊符号</span>
                </div>
              </div>
              <div class="write-txt">
                <p class="write-title">AI点评提示词：<span>*</span></p>
                <div class="write-text">
                  <!-- <input type="text" placeholder="最多输入3000个中/英、数字和特殊符号" v-model="item.comment_ai"> -->
                  <textarea placeholder="最多输入3000个中/英、数字和特殊符号" v-model="item.comment_ai"></textarea>
                  <span>最多输入3000个中/英、数字和特殊符号</span>
                </div>
              </div>
              <div class="write-txt" v-for="(ele,num) in item.comment_dim" :key="num">
                <p class="write-title">纬度{{num+1}}：<span>*</span></p>
                <div class="write-text">
                  <input type="text" placeholder="最多输入3000个中/英、数字和特殊符号" v-model="item.comment_dim[num]">
                  <span>最多输入3000个中/英、数字和特殊符号</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="video-list" v-else>
          <div class="video-item" v-for="(item,index) in examObj.level" :key="index" v-show="examIndex==index">
            <p class="write-title" style="display:block;margin-bottom:20px;">目标岗位：<span>*</span></p>
            <div class="write-txt" v-for="(ele,num) in item.topics" :key="'topic-' + num">
              <div class="write-text" v-for="(i,k) in ele.option" :key="k" style="margin-bottom:20px;">
                <div class="video-text">
                  <p>岗位名称{{k+1}}：</p>
                  <input type="text" placeholder="请填写岗位名称" v-model="i.content"> 
                  <button class="btn btn-video-add" @click="addVideo(item)">添加</button>
                  <button class="btn btn-video-remove" v-if="k>0" @click="removeVideo(item,k)">删除</button>
                </div>
                <div class="video-text">
                  <p>岗位介绍{{k+1}}：</p>
                  <textarea placeholder="请填写岗位介绍" v-model="i.value"></textarea>
                </div>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">关卡提示词：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.level_ai"></textarea>
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">AI点评提示词-文字：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.comment_ai"></textarea>
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">AI点评提示词-语音：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.comment_ai_audio"></textarea>
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">AI点评提示词-视频：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.comment_ai_video"></textarea>
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>

            <div class="write-txt" v-for="(ele,num) in item.comment_dim" :key="num"> 
              <p class="write-title">{{num==0?'内容维度':num==1?'视觉维度':'声音维度'}}<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="最多输入30个中/英、数字和特殊符号" v-model="item.comment_dim[num]"></textarea>
                <span>最多输入30个中/英、数字和特殊符号</span>
              </div>
            </div>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="examSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加练习</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.subtitle">{{item.subtitle}}</p>
              <p :title="item.type_name">{{item.type_name}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="关卡设置" class="btn btn-remove" @click="buildSub(item,'level')">关卡设置</button>
                <button title="练习设置" class="btn btn-remove" @click="buildSub(item,'exam')">练习设置</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import {getUploadToken, getPracticeList ,savePractice ,getPracticeTypeUseList ,getPracticeDetail,updatePracticeStatus,savePracticeLevel,savePracticeLevelTopic,getDigitalHumanUserList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "exam",
  data() {
    return {
      navId:'3',
      childrenID:'3-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'标题'},
        {id:3,title:'副标题'},
        {id:4,title:'类型'},
        {id:5,title:'发布状态'},
        {id:6,title:'添加时间'},
        {id:7,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        subtitle:'',
        image:'',
        type_id:'',
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/word_template.xlsx',
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      typeList:[],
      levelType:false,
      levelObj:{},
      levelIndex:1,
      examType:false,
      examIndex:0,
      loadTxt:'',
      loading:false,
      num:0,
      videoList:[],
      detailType:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };

      try {
        const response = await getDigitalHumanUserList(this.token);
        if(response.code == 200){
          response.data.forEach(function(item,index){
            that.videoList.push({id:item.id,video:'',name:item.name});
          })
          console.log(that.userList,'=====userList=')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getPracticeList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.getTypeList();
    },

    async getTypeList(){
      var that = this;
      try {
        const response = await getPracticeTypeUseList(this.token);
        if(response.code == 200){
          that.typeList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    async buildSub(e,type){
      var that = this;
      try {
        const response = await getPracticeDetail({id:e.id},this.token);
        if(response.code == 200){
          that.detailType = response.data.type;
          if(type == 'level'){
            that.levelObj = {
              id:e.id,
              num:response.data.num?response.data.num:'',
              level:response.data.level?response.data.level:[],
            };
            that.levelType = true;
          } else if(type == 'exam'){
            that.examObj = {
              id:e.id,
            };
            if(that.detailType == 1){
              var list = [];
              response.data.level.forEach(function(item,index){
                list.push(
                  {
                    plid:item.plid,
                    image_videos:item.image_videos?item.image_videos:that.videoList,
                    message:item.message,
                    dialogue_ai:item.dialogue_ai,
                    comment_ai:item.comment_ai,
                    comment_dim:item.comment_dim?item.comment_dim:['','','','',''],
                    topics:item.topics.length>0?item.topics:[{
                      fib: "",is_duration: 1,is_must: 1,option: [{content:'',is_vip:false}],topic: "练习时长",topic_ai: "",topic_type: 2
                    }]
                  }
                )
              });
              list.forEach(function(item,index){
                item.topics.forEach(function(ele,num){
                  if(ele.is_duration == 1){
                    ele.topic = '练习时长'  
                  } else {
                    if(ele.is_duration == 0){
                      if(ele.option.length > 0){
                        ele.option.forEach(function(i,k){
                          delete i.is_vip
                        });
                        console.log(ele.option,'=i===')
                      }
                    }
                  };
                  if(ele.option.length == 0){
                    if(ele.topic_type == 2){
                      ele.option.push({
                        content: '', is_vip: false
                      })
                    }
                  } else {
                    if(ele.topic_type == 1){
                      ele.option = [];
                    }
                    ele.option.forEach(function(i,k){
                      if(i.is_vip==1){
                        i.is_vip = true
                      } else if(i.is_vip == 0){
                        i.is_vip = false
                      }
                    })
                  }
                });

              })
              that.examObj.level = list;
            } else {
              var list = [];
              response.data.level.forEach(function(item,index){
                list.push(
                  {
                    plid:item.plid,
                    comment_ai:item.comment_ai?item.comment_ai:'',
                    comment_dim:item.comment_dim?item.comment_dim:['','',''],
                    level_ai:item.level_ai?item.level_ai:'',
                    comment_ai_video:item.comment_ai_video?item.comment_ai_video:'',
                    comment_ai_audio:item.comment_ai_audio?item.comment_ai_audio:'',
                    topics:item.topics.length>0?item.topics:[{
                      topic: "目标岗位",option: [{content:'',value:''}]
                    }]
                  }
                );
                that.examObj.level = list;
              });
            }
            console.log(that.detailType,that.examObj,'==level==')
            that.examType = true;
            that.$forceUpdate();
          } else {
            that.getTypeList();
            that.addType = 'edit';
            that.addObj = {
              title:response.data.title,
              subtitle:response.data.subtitle,
              type_id:response.data.type_id,
              image:response.data.image,
              id:response.data.id
            };
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    createSub(){
      this.levelObj.num = parseInt(this.levelObj.num);
      if(this.levelObj.level.length > this.levelObj.num){
        this.levelObj.level = this.levelObj.level.slice(0,parseInt(this.levelObj.num));
      } else if(this.levelObj.level.length < this.levelObj.num) { 
        var num = parseInt(this.levelObj.num - this.levelObj.level.length);
        for(var i = 0;i < num;i++){
          this.levelObj.level.push({num:parseInt(this.levelObj.level.length+1),title:'',subtitle:'',ph_name:'',ph_headpic:'',score:''})
        };
      }
    },

    levelSub(e,type,i){
      if(type == 'exam'){
        this.examIndex = i
      } else {
        this.levelIndex = e.num;
      }
    },

    // removeShow(e){
    //   this.removeID = e.id;
    //   this.removeType = true;
    // },

    // async removeSub(){
    //   var that = this;
    //   try {
    //     const response = await delDailyWord({id:this.removeID},this.token);
    //     if(response.code == 200){
    //       that.$message('删除成功');
    //       that.getList();
    //       that.ModelHide('remove');       
    //     } else {
    //       that.$message(response.msg);
    //     }
    //   } catch (error) {
    //     that.$message(error);
    //   }
    // },

    // ModelHide(type){
    //   var that = this;
    //   if(type == 'remove'){
    //     that.removeType = false;
    //     taht.removeID = '';
    //   }
    // },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入标题！');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请上传封面！');
        return false;
      }
      if(this.addObj.type_id == ''){
        that.$message('请选择练习类型！');
        return false;
      }
      try {
        const response = await savePractice(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.levelObj = {};
      this.examObj = {};
      this.levelType = false;
      this.examType = false;
      this.addObj = {
        chinese:'',
        english:'',
      }
      this.examIndex = 0;
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updatePracticeStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      if(type == 'ph_headpic'){
        that.levelObj.level[index].ph_headpic = response.key;
      } else if(type == 'user_banner'){
        that.examObj.level[index].image_videos[num].image = response.key;
        console.log(type,index,num,that.examObj.level,'==type==')
        // that.$forceUpdate();
      } else {
        that.addObj.image = response.key;
      }
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    beforeUploadVideo(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessVideo(response, file, fileList,index,type,num) {
      console.log(type,'==type==')
      if(type == 'video'){
        this.examObj.level[index].image_videos[num].video = response.key;
      } else {
        this.examObj.level[index].image_videos[num].static_video = response.key;
      }
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemoveVideo(response, file, fileList,index,type,num) {
      if(type == 'video'){
        this.examObj.level[index].image_videos[num].static_video = '';
      } else {
        this.examObj.level[index].image_videos[num].video = '';
      }
    },

    async levelSave(){
      var that = this;
      try {
        const response = await savePracticeLevel(this.levelObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicChange(e,i,n){
      var topics = this.examObj.level[i].topics;
      var topic_type = topics[n].topic_type;
      if(topic_type == 2){
        topics[n].option = [{content:'',is_vip:false}]
      };
      this.$forceUpdate();
    },

    timeAdd(e){
      e.option.push({content:'',is_vip:false});
      this.$forceUpdate();
    },

    timeRemove(e,k){
      e.option.splice(k,1);
      this.$forceUpdate();
    },

    optionAdd(e){
      e.option.push({content:''});
      this.$forceUpdate();
    },

    optionRemove(e,k){
      e.option.splice(k,1);
      this.$forceUpdate();
    },

    userAdd(e){
      e.image_videos.push({
        image: "",
        static_video: "",
        video: ""
      })
      this.$forceUpdate();
    },
  
    userRemove(e,n){
      console.log(e,'==e==')
      e.image_videos.splice(n,1);
      this.$forceUpdate();
    },

    async examSub(){
      var that = this;
      if(that.detailType == 1){
        this.examObj.level.forEach(function(item,index){
          item.topics.forEach(function(ele,num){
            if(ele.option.length > 0){
              ele.option.forEach(function(i,k){
                if(i.is_vip){
                  i.is_vip = 1
                } else if(i.is_vip == false) {
                  i.is_vip = 0
                }
              })
            }
          })
        })
      }
      console.log(this.examObj,'==examobj==');
      try {
        const response = await savePracticeLevelTopic(this.examObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    questionAdd(i){
      console.log(this.examObj.level[i])
      this.examObj.level[i].topics.push({fib: "",is_duration: 0,is_must: 1,option: [{content:'',is_vip:false}],topic: "",topic_ai: "",topic_type: 1});
      this.$forceUpdate();
    },

    questionRemove(i,n){
      this.examObj.level[i].topics.splice(n,1);
      this.$forceUpdate();
    },

    addVideo(e){
      e.topics[0].option.push({content:'',value:''})
      this.$forceUpdate();
    },

    removeVideo(item,num){
      item.topics[0].option.splice(num,1);
      this.$forceUpdate();
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 7 );
  }

  .dataList .listItem p .btn{
    display: block;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
    height: 90%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    width: 200px;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text input{
    width: 200px;
    background-color: #F5F5F5;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox.levelBox .write-text{
    width: auto;
  }

  .MobelBox .write-level .write-title{
    width: auto;
    padding: 10px;
    box-sizing: border-box;
    border: solid 1px #ccc;
    border-radius: 5px;
    margin: 0 5px 0 0;
  }

  .MobelBox .write-level .write-title.select{
    background-color: #6E2FFF;
    color: #fff;
  }

  .MobelBox .video-upload .write-txt input{
    width: 200px;
    border-radius: 5px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    display: inline-block;
    vertical-align: top;
    background-color: #f5f5f5;
    margin-left: 20px;
  }

  .btn-create{
    display: inline-block;
    vertical-align: top;
    width: 116px;
    height: 53px;
    background-color: #6E2FFF;
    border-radius: 16px;
    color: #fff;
    padding: 0;
    margin: 0 30px 0 0;
    outline: none;
    font-size: 18px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.examBox .userList{
  font-size: 0;
  display: block;
}

.examBox .userList .user-item{
  display: block;
}

.examBox .user-item-name{
  font-size: 0;
  display: block;
  margin: 10px 0;
}

.examBox .user-item-name .user-title{
  font-size: 18px;
  color: #333;
  display: block;
  margin-bottom: 10px;
  display: inline-block;
}

.examBox .user-item-name .btn{
  font-size: 14px;
  color: #fff;
  background-color: #6E2FFF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px 20px;
  display: inline-block;
  margin-left: 10px;
}

.examBox .user-item-name .btn.btn-remove{
  background-color: #E2231A;
}

.examBox .video-upload {
  margin-top: 20px;
}

.examBox .video-upload .write-text,
.examBox .video-upload .write-title{
  width: auto;
}

.examBox .question-item{
  display: block;
}

.examBox .question-item .question-text{
  font-size: 0;
  margin-bottom: 20px;
}

.examBox .question-item .question-text .question-title{
  display: inline-block;
  margin: 10px 0;
  font-size: 18px;
  color: #333;
}

.examBox .question-cont{
  font-size: 0;
  margin-top: 20px;
}

.examBox .question-cont .question-cont-title,
.examBox .question-cont .question-cont-time{
  display: inline-block;
  vertical-align: top;
  font-size: 18px;
  color: #333;
}

.examBox .question-cont .question-cont-title{
  width: 150px;
}

.examBox .question-cont .question-cont-time .time{
  display: block;
  margin-top: 10px;
}

.examBox .question-cont .question-cont-time input{
  border: solid 1px #ccc;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  width: 200px;
}

.examBox .question-cont .question-cont-time textarea{
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  height: 80px;
  width: 400px;
}

.examBox .question-cont .btn,
.examBox .time .btn{
  box-sizing: border-box;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 0 10px;
}

.examBox .question-cont .btn-option-add,
.examBox .btn-time-add{
  background-color: #6E2FFF;
  color: #fff;
}

.examBox .question-cont .btn-option-remove,
.examBox .btn-time-remove{
  background-color: #E2231A;
  color: #fff;
}

.examBox .comment{
  display: block;
  margin-top: 20px;
}

.question-btnBox{
  display: inline-block;
  vertical-align: top;
  margin-left: 30px;
}

.question-btnBox .btn{
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background-color: #6E2FFF;
  color: #fff;
  margin-left: 30px;
}

.question-btnBox .btn.btn-question-remove{
  background-color: #E2231A;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.video-item,
.video-list{
  display: block;
}

.video-text{
  display: block;
  font-size: 0;
  margin-bottom: 20px;
}

.video-text:last-child{
  margin-bottom: 0;
}

.video-text p{
  font-size: 18px;
  color: #333;
  display: inline-block;
  vertical-align: top;
  line-height: 40px;
  height: 40px;
}

.video-text .btn-video-remove,
.video-text .btn-video-add{
  font-size: 18px;
  color: #fff;
  background-color: #6E2FFF;
  box-sizing: border-box;
  padding: 10px 15px;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.video-text .btn-video-remove{
  background-color: #E2231A;
}

.MobelBox .write-text .video-text textarea,
.MobelBox .write-text .video-text input{
  font-size: 18px;
  color: #333;
  display: inline-block;
  vertical-align: top;
  width: 50%;
}

.MobelBox .write-text .video-text textarea{

}
</style>



// WEBPACK FOOTER //
// src/speech/exam.vue